module.exports = __webpack_public_path__ + "static_pc/img/charIMG.ede087a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/charIMG.jpg
// module id = Ko47
// module chunks = 1